import { css } from '@linaria/atomic';
import { Variants } from 'motion/react';
import type { DrawerSide } from './types';

export const drawerSizes = {
  small: 360,
  smallXL: 400,
  smallXXL: 434,
  medium: 500,
  large: 600,
  xlarge: 700,
  full: '100%',
} as const;

export const createDrawerVariants = (keepMounted: boolean): Record<DrawerSide, Variants> => ({
  left: {
    hidden: {
      transform: 'translateX(-100%)',
      opacity: 0,
      ...(keepMounted && { display: 'none' }),
    },
    visible: {
      transform: 'translateX(0)',
      opacity: 1,
      ...(keepMounted && { display: 'block' }),
    },
    exit: {
      transform: 'translateX(-100%)',
      ...(keepMounted && { display: 'none' }),
    },
  },
  right: {
    hidden: {
      transform: 'translateX(100%)',
      opacity: 0,
      ...(keepMounted && { display: 'none' }),
    },
    visible: {
      transform: 'translateX(0)',
      opacity: 1,
      ...(keepMounted && { display: 'block' }),
    },
    exit: {
      transform: 'translateX(100%)',
      ...(keepMounted && { display: 'none' }),
    },
  },
  top: {
    hidden: { transform: 'translateY(-100%)', opacity: 0 },
    visible: { transform: 'translateY(0)', opacity: 1 },
    exit: { transform: 'translateY(-100%)', opacity: 0 },
  },
  bottom: {
    hidden: { transform: 'translateY(100%)', opacity: 0 },
    visible: { transform: 'translateY(0)', opacity: 1 },
    exit: { transform: 'translateY(100%)', opacity: 0 },
  },
});

export const backdropVariants: Variants = {
  hidden: {
    opacity: 0,
  },
  visible: {
    opacity: 1,
  },
  exit: {
    opacity: 0,
  },
};

/** Static Linaria class per side — position props that don't depend on runtime offset. */
export const sideStaticStyles: Record<DrawerSide, string> = {
  left: css`
    left: 0;
    bottom: 0;
  `,
  right: css`
    right: 0;
    bottom: 0;
  `,
  top: css`
    left: 0;
    right: 0;
  `,
  bottom: css`
    bottom: 0;
    left: 0;
    right: 0;
  `,
};

/**
 * Returns the inline `top` style for sides that need a dynamic height offset.
 * `bottom` panels anchor to the bottom edge and never use `top`.
 */
export const getSideTopOffset = (side: DrawerSide, offset: number): React.CSSProperties =>
  side !== 'bottom' ? { top: `${offset}px` } : {};

export const drawerBackdropId = 'drawer-backdrop-overlay';
